import React from "react";
import styles from "./styles.module.css";

export const DropdownMenu = ({
  isOpen,
  children,
}: {
  isOpen: boolean;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.dropdownMenu}>
      <div className={styles.dropdownMenuOptions}>{children}</div>
    </div>
  );
};
